import { render } from "./TimeComponent.vue?vue&type=template&id=492cbeac"
import script from "./TimeComponent.vue?vue&type=script&lang=js"
export * from "./TimeComponent.vue?vue&type=script&lang=js"
script.render = render

export default script